import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { HomeModule } from 'src/app/home/home.module';
import { UploadKycModule } from 'src/app/upload-kyc/upload-kyc.module';
import { ErrorModule } from 'src/app/error/error.module';
import { SuccessModule } from 'src/app/success/success.module';
import { KycModule } from 'src/app/kyc/kyc.module';
import { KycRedirectErrorModule } from 'src/app/kyc-redirect-error/kyc-redirect-error.module';
import { KycVerifyModule } from 'src/app/kyc-verify/kyc-verify.module';
import { KycLinkResultsModule } from 'src/app/kyc-link-results/kyc-link-results.module';
import { KycHypervergeModule } from '../kyc-hyperverge/kyc-hyperverge.module';
import { KycStatusResultsModule } from '../kyc-status-results/kyc-status-results.module';
import { KycSearchModule } from '../kyc-search/kyc-search.module';
import { KycMarutiModule } from '../kyc-maruti/kyc-maruti.module';
import { AuthGuard } from '../login/auth.guard';
import { KycCustomerSearchModule } from '../kyc-customer-search/kyc-customer-search.module';
import { KycMarutiJourneyModule } from '../kyc-maruti-journey/kyc-maruti-journey.module';
import { CkycDocumentsModule } from '../ckyc-maruti-documents/ckyc-documents.module';
import { ManualkycDocumentsModule } from '../manualkyc-maruti-documents/manualkyc-documents.module';

const routes: Routes = [
    {
        path: '', component: LayoutComponent,
         children: [
            { path: "", redirectTo: '/login', pathMatch: 'full' },
            { path: "oem", redirectTo: '/oem/kycVerification', pathMatch: 'full' },
            { path: 'error', loadChildren: () =>  ErrorModule },
            { path: 'Home', loadChildren: () =>  HomeModule },
            { path: 'UploadKyc', loadChildren: () =>  UploadKycModule} ,
            { path: 'Error', loadChildren: () =>  ErrorModule} ,
            { path: 'Success', loadChildren: () =>  SuccessModule} ,
            { path: 'KYCUpload', loadChildren: () =>  KycModule} ,
            { path: 'KYCRedirectError', loadChildren: () => KycRedirectErrorModule},
            { path: 'verifyKYC', loadChildren: () => KycVerifyModule},
            { path: 'kycResults', loadChildren: () => KycLinkResultsModule},
            { path: 'doKyc', loadChildren: () => KycHypervergeModule,canActivate: [AuthGuard]},
            { path: 'kycStatus', loadChildren: () => KycStatusResultsModule,canActivate: [AuthGuard]},
            { path: 'kyc-search', loadChildren: () => KycSearchModule,canActivate: [AuthGuard]} ,
            { path: 'oem/kycVerification', loadChildren: () => KycMarutiModule},
            { path: 'customer-kyc-search', loadChildren: () => KycCustomerSearchModule} ,
            { path: 'kyc-maruti',loadChildren: () => KycMarutiJourneyModule},
            { path: 'ckyc-maruti-documents',loadChildren: () => CkycDocumentsModule},
            { path: 'manualkyc-maruti-documents',loadChildren: () => ManualkycDocumentsModule},
            { path: 'success',loadChildren: () => SuccessModule}
         ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LayoutRoutingModule { }
